import React, { useState, useEffect, useMemo } from 'react';
import styles from "./AsadoConCueroMap.module.scss";

// Función auxiliar para formatear moneda
const formatCurrency = (value) => {
  return new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
};

const AsadoConCueroMap = ({ evento, onSeatsSelected }) => {
  const [selectedSection, setSelectedSection] = useState(null);
  const [selectedSeats, setSelectedSeats] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const tiposDeTickets = useMemo(() => {
    return evento.tiposDeTickets.filter(ticket => ticket.fila && ticket.numeroAsiento);
  }, [evento.tiposDeTickets]);

  useEffect(() => {
    if (onSeatsSelected) {
      const selectedSeatsDetails = selectedSeats.map((seatId) => {
        const seat = tiposDeTickets.find((ticket) => ticket.id === seatId);
        return {
          id: seat.id,
          nombre: seat.nombre,
          precio: seat.precio,
          fila: seat.fila,
          numeroAsiento: seat.numeroAsiento,
        };
      });
      onSeatsSelected(selectedSeatsDetails);
    }
  }, [selectedSeats, tiposDeTickets, onSeatsSelected]);

  const handleSectionClick = (sectionName) => {
    setSelectedSection(sectionName);
    setModalIsOpen(true);
  };

  const toggleSeatSelection = (ticketId) => {
    setSelectedSeats((prevSelectedSeats) => {
      if (prevSelectedSeats.includes(ticketId)) {
        return prevSelectedSeats.filter(id => id !== ticketId);
      } else {
        return [...prevSelectedSeats, ticketId];
      }
    });
  };

  const removeSeatSelection = (ticketId) => {
    setSelectedSeats((prevSelectedSeats) =>
      prevSelectedSeats.filter((id) => id !== ticketId)
    );
  };

  const groupedByRow = useMemo(() => {
    const grouped = tiposDeTickets.reduce((acc, ticket) => {
      if (!acc[ticket.fila]) {
        acc[ticket.fila] = [];
      }
      acc[ticket.fila].push(ticket);
      return acc;
    }, {});
    Object.keys(grouped).forEach(fila => {
      grouped[fila].sort((a, b) => a.numeroAsiento - b.numeroAsiento);
    });
    return grouped;
  }, [tiposDeTickets]);

  const getSeatColor = (ticket) => {
    if (ticket.estado === 'VENDIDA') return 'red';
    if (ticket.estado === 'RESERVADA') return 'orange';
    if (selectedSeats.includes(ticket.id)) return 'green';
    return '#ccc';
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <div className={styles.eventContainer}>
      <div className={styles.contMap}>
        <img
          src="https://simplepassbucket.s3.sa-east-1.amazonaws.com/img/Asado+con+cuero/layout-vfbc.webp"
          alt="Plano del evento"
          className={styles.eventImage}
        />
        
        {/* Botones invisibles para seleccionar secciones */}
        <button
          className={`${styles.invisibleButton} ${styles.sectionA1}`}
          onClick={() => handleSectionClick('A1')}
        />
        <button
          className={`${styles.invisibleButton} ${styles.sectionA2}`}
          onClick={() => handleSectionClick('A2')}
        />
        <button
          className={`${styles.invisibleButton} ${styles.sectionB1}`}
          onClick={() => handleSectionClick('B1')}
        />
        <button
          className={`${styles.invisibleButton} ${styles.sectionB2}`}
          onClick={() => handleSectionClick('B2')}
        />
        <button
          className={`${styles.invisibleButton} ${styles.sectionC1}`}
          onClick={() => handleSectionClick('C1')}
        />
        <button
          className={`${styles.invisibleButton} ${styles.sectionC2}`}
          onClick={() => handleSectionClick('C2')}
        />
      </div>

      <div className={styles.selectedSeatsContainer}>
        <h4 className={styles.seleccionados}>Butacas seleccionadas:</h4>
        {selectedSeats.map((seatId) => {
          const seat = tiposDeTickets.find((ticket) => ticket.id === seatId);
          return (
            <div key={seat.id} className={styles.selectedSeat}>
              <span>{`${seat.nombre} - ${formatCurrency(seat.precio)}`}</span>
              <button
                className={styles.removeButton}
                onClick={() => removeSeatSelection(seat.id)}
              >
                X
              </button>
            </div>
          );
        })}
      </div>

      {/* Modal para la selección de asientos */}
      {modalIsOpen && (
        <div className={styles.modalOverlay} onClick={closeModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button className={styles.closeIcon} onClick={closeModal}>&times;</button>
            <div className={styles.modalHeader}>
              <h2>Sección {selectedSection}</h2>
            </div>
            <div className={styles.seatsContainer}>
              {Object.keys(groupedByRow)
                .filter(fila => tiposDeTickets.find(ticket => ticket.fila === fila && ticket.seccion === selectedSection))
                .map(fila => (
                  <div key={fila} className={styles.rowContainer}>
                    {groupedByRow[fila]
                      .filter(ticket => ticket.seccion === selectedSection)
                      .map(ticket => (
                        <button
                          key={ticket.id}
                          className={styles.seatButton}
                          style={{ backgroundColor: getSeatColor(ticket) }}
                          onClick={() => toggleSeatSelection(ticket.id)}
                          disabled={ticket.estado !== 'DISPONIBLE'}
                        >
                          {`${ticket.fila}-${ticket.numeroAsiento}`}
                        </button>
                      ))}
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AsadoConCueroMap;